import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PublicHeaderComponent } from '../public-header/public-header.component';
import { RouterOutlet } from '@angular/router';
import { B2bFooterComponent } from '@ui/global-shared/components/b2b-footer/b2b-footer.component';

@Component({
  selector: 'pt-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PublicHeaderComponent, RouterOutlet, B2bFooterComponent],
})
export class PublicLayoutComponent {}
